import { render, staticRenderFns } from "./FooterWrapper.vue?vue&type=template&id=008cff19&scoped=true&"
import script from "./FooterWrapper.vue?vue&type=script&lang=ts&"
export * from "./FooterWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./FooterWrapper.vue?vue&type=style&index=0&id=008cff19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008cff19",
  null
  
)

export default component.exports